class VideoParallax extends HTMLElement {
    constructor() {
      super();
      this.classes = {
        desktop: 'parallax--desktop',
        mobile: 'parallax--mobile'
      }

      this.mobileBreakpoint = 768;

      this.parallaxContainer = this.querySelector('.js-index-video-parallax-container');
      
      this.video = this.parallaxContainer.dataset.videoSrc
      this.videoPoster = this.parallaxContainer.dataset.imgSrc;
      
      this.mobileVideo = this.parallaxContainer.dataset.mobileVideoSrc;
      this.mobilePoster = this.parallaxContainer.dataset.mobileImgSrc;

      this.parallaxSpeed = this.parallaxContainer.dataset.speed;
      
      this.init();
    }

  init(){
    
    this.initParallax();
    this.setupEventListeners();
  }

  setupEventListeners(){
    window.addEventListener('resize', debounce(this.initParallax.bind(this), 500));
  }

  initParallax(){
    let windowWidth = window.innerWidth;

    if(windowWidth <= this.mobileBreakpoint && !this.parallaxContainer.classList.contains(this.classes.mobile)){
     
      console.log('init mobile')
      
      //init parallax on mobile
      this.destroyParallax();
      this.parallax(this.mobileVideo, this.mobilePoster);
      this.parallaxContainer.classList.add(this.classes.mobile);
      
    }else if(windowWidth > this.mobileBreakpoint && !this.parallaxContainer.classList.contains(this.classes.desktop)){

      console.log('init desktop')
      
      //init parallax on desktop
      this.destroyParallax();
      this.parallax(this.video, this.videoPoster);
      this.parallaxContainer.classList.add(this.classes.desktop);
    }
    
  }

  parallax(videoSrc, poster){
    const parallaxContainer = this.parallaxContainer;
    jarallaxVideo();
    jarallax(this.parallaxContainer, {
      imgSrc: poster,
      speed: this.parallaxSpeed,
      videoSrc: videoSrc,
      onInit: function () {
        const posterImg = parallaxContainer.querySelector('.jarallax-container img');
        const posterAlt = parallaxContainer.dataset.imgAlt;
        console.log(posterImg, posterAlt)
        if (posterImg && posterAlt) {
          posterImg.alt = posterAlt;
        }
      }
    });


  }

  destroyParallax(){
    jarallax(this.parallaxContainer, 'destroy');
    this.parallaxContainer.classList.remove(this.classes.mobile, this.classes.desktop);
  }
}
  
  customElements.define('video-parallax', VideoParallax);